import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/created-by-list';
import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUserViewInImport from "../../import/view-in-preview/user-view-in-preview";

export default class AssignedToField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.CREATED_BY;
    }

    get sortHintMessage() {
        return 'Sort by created by';
    }

    getCsvValue(item) {
        const user = gd.session.users.get(item.createdByUserId);
        return user ? user.name : '';
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => (i.type === 'project' || !i.item.createdByUserId) ? '-' : gd.session.users.get(i.item.createdByUserId).name.toLowerCase()],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, 'gd-field-created-by', 'None');
    }

    // IMPORT - not sure esli eto vozmozno kstati no pust' budet

    normalizeCSVValue(value) {
        return mapByUserName(gd.companyId, value);
    }

    getComponentViewInImport() {
        return SystemFieldUserViewInImport;
    }
}